<template>
  <div>
    <h1 class="main-header" v-translate translate-context="chargebackType">Create</h1>
    <ChargebackTypeForm :data="empty" @save="onSave" :save_text="$pgettext('form', 'Create')"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {SuccessNotification} from "@/domain/core/exception/exceptions";
import ChargebackTypeForm from "@/domain/chargebackType/components/ChargebackTypeForm.vue";

export default {
  name: 'NewChargebackType',
  components: {ChargebackTypeForm},
  data() {
    return {
      empty: {
        name: {},
        code: '',
        is_active: true,
      }
    }
  },
  methods: {
    ...mapActions('chargebackType', ['createChargebackType']),

    async onSave(data) {
      await this.createChargebackType(data)
      await this.$router.push({name: 'chargebackType.list'})
      throw new SuccessNotification(this.$pgettext('chargebackType', 'Dispute type created!'))
    }
  }
}
</script>
